import React  from "react";
import PropTypes from "prop-types";

import Slider from "@material-ui/core/Slider";
import Box from "@mui/material/Box";
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';


const muiTheme3 = createTheme({
    
    overrides: {
        MuiSlider: {
            thumb: {
                color: "grey",
                size:12,
            },
            track: {
                color: 'grey'
            },
            rail: {
                color: 'black',
            }
        },
        
    },
    typography: {
        fontFamily: 'Objective-Regular',
        fontSize: 14,
    },
    palette: {
        text: {
            primary: 'black',
            secondary: 'black',
            disabled: 'grey'
        }
    }

});


function valuetext(value) {
    return `${value}%`;
}


function calcScale(min, max) {
    let scale = [];
    let medValue = Math.round((min + max) / 2);
    scale.push({ value: min, label: min.toString() });
    scale.push({ value: medValue, label: medValue.toString()  });
    scale.push({ value: max, label: max.toString() + "%" });

    return scale;
}


const ZoomSlider = ( props ) => {
    const { min, max, posTemp, handleValueChange, zoomValue, disabled  } = props;
    const scale = calcScale(min, max);
    const [value, setValue] = React.useState(Number(zoomValue.toFixed(0)));

    const handleChange = (event, newValue) => {
        event.preventDefault();
        if (value !== newValue && newValue > 0) { 
            //console.log(newValue);
            handleValueChange(newValue);
            setValue(newValue);
        }
    };
    

    return (
        <ThemeProvider theme={muiTheme3}>
            <Box sx={{width: '90%'}}>
                <Slider
                    key={`zoom-${posTemp}-${min}-${max}`}
                    aria-label="Zoom Image"
                    disabled={disabled}
                    value={Number(zoomValue.toFixed(0))}
                    getAriaValueText={valuetext}
                    valueLabelDisplay="auto"
                    step={1}
                    marks={scale}
                    min={0}
                    max={500}
                    onChange={handleChange}
                />    
            </Box>
        </ThemeProvider>
    );
}

export default ZoomSlider;

ZoomSlider.propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    zoomValue: PropTypes.number.isRequired,
    posTemp: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
}